import { render, staticRenderFns } from "./QuestionShort.vue?vue&type=template&id=52c00c04&scoped=true&"
import script from "./QuestionShort.vue?vue&type=script&lang=ts&"
export * from "./QuestionShort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c00c04",
  null
  
)

export default component.exports